import { chance } from 'helpers';
import * as setup from 'setup';
import Food from '../Food/Food';
import Ant from './Ant';

export default class AntWorker extends Ant {

    target?: Food | null;

    carryAmount = 0;
    income = 0;
    revealedFog = false;
    targetTrip = 0;

    constructor(gameState: GameState, props?: AntProps, state?: any) {
        super(gameState, 'worker', setup.ants.worker, props, state);
    }

    init = () => {
        this.onMove();
        this.findFood();
    }

    onMove = () => {
        const cellNames = this.gameState.revealFog(this.cell, this.setup.revealDistance || 1);
        if (cellNames.length) {
            this.revealedFog = true;
        }
    }

    findFood = () => {
        // Check paradise
        if (this.gameState.unlocks.paradise) {
            return this.moveToParadise();
        }
        
        if (!this.target || chance(this.setup.retargetChance)) {
            // Get closest found or hidden food
            const targets = [
                this.gameState.entities.foods.active.filter(food => food.active && food.found),
                this.gameState.entities.foods.active.filter(food => food.active && !food.found),
            ];
            const maxDistance = this.colony.getMaxCarryDistance();
            const target = this.colony.getClosestPreferredTarget(targets, maxDistance);

            // Check if it's the same target
            if (this.target !== target) {
                this.target = target;
                this.targetTrip = this.target ? (this.colony.getStepsTo(this.target.cell) * 2 / this.getMovingSpeed() + 1) : 0;
                this.targetEngaged = false;
                this.income = 0;
            }
        }

        // If close enough move to, otherwise wander towards
        if (this.target?.found && (this.targetEngaged || this.isCloseToTarget(this.target, this.setup.searchDistance))) {
            this.moveTo(this.target.cell, this.target.size / 2 - 1, this.gatherFood);
        } else if (this.revealedFog) {
            this.revealedFog = false;
            this.wanderTo(this.moveDeparture, 0.8, this.findFood); // To make ants more/less timid - adjust this.
        } else if (this.target) {
            this.wanderTo(this.target.cell, this.getWanderAttraction(), this.findFood);
        } else {
            this.wanderTo(this.colony.cell, 0.1, this.findFood);
        }
    }

    gatherFood = () => {
        this.queue(this.carryFood, true);
    }

    carryFood = () => {
        this.carryAmount = (this.isCloseToTarget(this.target) && this.target?.grabCalories(this.getCarryCapacity())) || 0;

        if (this.carryAmount) {
            this.income = this.targetTrip ? (this.carryAmount / this.targetTrip) : 0;
            this.targetEngaged = true;
            this.moveToTarget(this.colony, this.dropFood);
        } else {
            this.wanderTo(this.cell, 0, this.findFood);
        }
    }

    dropFood = () => {
        this.playSound('food-drop',0.9);
        this.colony.indicate(`+${this.carryAmount}`);
        this.gameState.addCalories(this.carryAmount);
        this.carryAmount = 0;
        this.queue(this.findFood);
    }

    getCarryCapacity = () => {
        return (this.setup.carryCapacity || 0) * (this.gameState.entities.ants.buffs.carry + 1);
    }

    getWanderAttraction = () => {
        // If player is on the verge of starving, increase attraction to force finding food
        if (this.gameState.calories < 20) {
            return 0.7;
        }

        // If any food has been found, increase attraction
        if (this.gameState.entities.foods.active.some(food => food.found)) {
            return 0.5;
        }

        // Make first antworker move towards food - make others random.
        const firstWorker = this.gameState.entities.ants.workers.active[0];
        return (this === firstWorker || firstWorker?.targetEngaged) ? 0.5 : 0;
    }

    getWanderDistance = () => {
        // If AntWarriors present use multiplier, otherwise normal
        return (this.gameState.entities.ants.warriors.active.length ? 4 : 1) * (this.setup.wanderDistance || 0);
    }

}